import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPreloadedImage } from "../assets/js/images";
import {
  addAllSections,
  changeSection,
  toggleSectionContentDisplay,
} from "../store/auxiliary/ui/sections";
import MainSectionImage from "./MainSectionImage";

import closeIcon from "../assets/images/close_section.svg";
import {
  getRightContent,
  getSectionContent,
  numberWithCommas,
  setAdditionalClasses,
  shiftImageIndex,
} from "../assets/js/utils";
import Navbar from "./Navbar";
import {
  getMenuItems,
  getNextSectionContentIndex,
  getPrevSectionContentIndex,
  getSections,
} from "../assets/js/content";
import Logo from "./Logo";
import MainText from "./MainText";
import Counter from "./Counter";
import InfoDescriptor from "./InfoDescriptor";
import TableDescriptor from "./TableDescriptor";
import InfoBarDescriptor from "./InfoBarDescriptor";
import MediaItem from "./MediaItem";
import TabSelector from "./TabSelector";
import {
  toggleLanguage,
  toggleMenu,
} from "../store/auxiliary/ui/generalSettings";
import NavbarList from "./NavbarList";
import MenuOpen from "./MenuOpen";
import useScrollYNavbarChecker from "./hooks/useScrollYNavbarChecker";
import Section2 from "./sections/Section2";
import Section6 from "./sections/Section6";
import Section5 from "./sections/Section5";
import Section4 from "./sections/Section4";
import Section3 from "./sections/Section3";
import Section1 from "./sections/Section1";
import Footer from "./Footer";
import constants from "../assets/js/constants";
import menuIcon from "../assets/images/menu-primary.png";
import LanguageToggler from "./LanguageToggler";

const thresholdToChangeSectionInMs = 1700;

function MainContainer(props) {
  const [applyAnimationStart, setApplyAnimationStart] = useState(false);
  const [applyAnimationReverse, setApplyAnimationReverse] = useState(false);
  const [applyAnimationVanish, setApplyAnimationVanish] = useState(false);
  const [decreaseIndex, setDecreaseIndex] = useState(false);
  const [increaseIndex, setIncreaseIndex] = useState(false);
  const [pressedMenuIndex, setPressedMenuIndex] = useState(0);
  const [applyAnimationMenuAppear, setApplyAnimationMenuAppear] =
    useState(false);
  const [closeContent, setCloseContent] = useState(false);
  const [pressLogo, setPressLogo] = useState(false);
  const [closeMenu, setCloseMenu] = useState(false);
  const [menuItemPressedInContent, setMenuItemPressedInContent] =
    useState(false);
  const [languageTogglerPressed, setLanguageTogglerPressed] = useState(false);

  const [swipeLeft, setSwipeLeft] = useState(false);
  const [swipeRight, setSwipeRight] = useState(false);
  const [startMouseDown, setStartMouseDown] = useState(false);

  // const [firstClientX, setFirstClientX] = useState(0);
  const [clientX, setClientX] = useState(null);
  const [clientY, setClientY] = useState(null);

  const [canChangeSection, setCanChangeSection] = useState(true);

  const scrollEnableSticky = useScrollYNavbarChecker();

  const sections = useSelector((state) => state.ui.sections);
  const generalSettings = useSelector((state) => state.ui.generalSettings);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(addAllSections(getSections()));
  }, []);

  useEffect(() => {
    function onWheel(e) {
      if (!sections.displayContent) {
        if (e.deltaY > 0) {
          if (canChangeSection) handleNextSection();
        } else if (e.deltaY < 0) {
          if (canChangeSection) handlePrevSection();
        }
      }
    }

    function onPointerDown(e) {
      // e.preventDefault();
      if (!sections.displayContent) {
        setClientX(e.clientX);
        if (!startMouseDown) {
          // setFirstClientX(e.clientX);
        }
        setStartMouseDown(true);
      }
    }

    // function onMouseMove(e) {
    //   console.log("mouse move", e);
    //   e.preventDefault();
    //   if (!sections.displayContent) {
    //     if (startMouseDown) {
    //       setClientX(e.clientX);
    //     }
    //   }
    // }

    function onTouchStart(e) {
      if (!sections.displayContent) {
        setClientX(e.touches[0].clientX);
        setClientY(e.touches[0].clientY);
        setStartMouseDown(true);
      }
    }

    function onTouchMove(e) {
      if (!sections.displayContent) {
        if (!clientX) return;

        const xDiff = clientX - e.touches[0].clientX;
        if (xDiff > 200) setSwipeRight(true);
        else if (xDiff < -200) setSwipeLeft(true);
      }
    }

    function onTouchEnd(e) {
      if (!sections.displayContent && clientX) {
        const xDiff = clientX - e.changedTouches[0].clientX;
        const yDiff = clientY - e.changedTouches[0].clientY;
        const isHorizontalSwipe = Math.abs(xDiff) > Math.abs(yDiff);
        if (isHorizontalSwipe) {
          if (xDiff > 100 && canChangeSection) setSwipeRight(true);
          else if (xDiff < -100 && canChangeSection) setSwipeLeft(true);

          setClientX(null);
        } else {
          if (
            yDiff > 100 &&
            sections.currentSection !== 0 &&
            canChangeSection
          ) {
            handleReadMore();
            setClientY(null);
          }
        }
      }
    }

    function onPointerUp(e) {
      // e.preventDefault();
      if (!sections.displayContent) {
        if (startMouseDown) {
          // if (firstClientX > clientX && firstClientX - clientX > 100) {
          //   setSwipeLeft(true);
          // } else if (firstClientX < clientX && clientX - firstClientX > 100) {
          //   setSwipeRight(true);
          // }
          if (clientX != 0 && e.clientX > clientX && e.clientX - clientX > 100)
            setSwipeRight(true);
          else if (
            clientX != 0 &&
            e.clientX < clientX &&
            clientX - e.clientX > 100
          )
            setSwipeLeft(true);

          // setFirstClientX(0);
          setClientX(0);
          setStartMouseDown(false);
        }
      }
    }
    window.addEventListener("wheel", onWheel);
    // window.addEventListener("pointerdown", onPointerDown, false);
    window.addEventListener("touchstart", onTouchStart, false);
    window.addEventListener("touchend", onTouchEnd, false);
    // window.addEventListener("touchmove", onTouchMove, false);
    // window.addEventListener("mousemove", onMouseMove);
    // window.addEventListener("pointerup", onPointerUp, false);

    return function () {
      window.removeEventListener("wheel", onWheel);
      // window.removeEventListener("pointerdown", onPointerDown);
      // window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("touchstart", onTouchStart);
      window.removeEventListener("touchend", onTouchEnd);
      // window.removeEventListener("touchmove", onTouchMove);
      // window.removeEventListener("pointerup", onPointerUp);
    };
  }, [sections, startMouseDown, clientX, clientY, canChangeSection]);

  useEffect(() => {
    if (swipeLeft) {
      handlePrevSection();
      setSwipeLeft(false);
    } else if (swipeRight) {
      handleNextSection();
      setSwipeRight(false);
    }
  }, [swipeLeft, swipeRight]);
  useEffect(() => {
    if (applyAnimationVanish) {
      if (increaseIndex) {
        setIncreaseIndex(false);

        setTimeout(() => {
          // setImageIndex((prev) => prev + 1);
          dispatch(
            changeSection(
              shiftImageIndex(
                sections.currentSection,
                true,
                sections.list.length
              )
            )
          );
          setApplyAnimationVanish(false);
          setApplyAnimationReverse(false);
          setApplyAnimationMenuAppear(true);
        }, 800);
      } else if (decreaseIndex) {
        setDecreaseIndex(false);
        setTimeout(() => {
          // setImageIndex((prev) => prev - 1);
          dispatch(
            changeSection(
              shiftImageIndex(
                sections.currentSection,
                false,
                sections.list.length
              )
            )
          );
          setApplyAnimationReverse(false);
          setApplyAnimationVanish(false);
          setApplyAnimationMenuAppear(true);
        }, 800);
      } else if (pressedMenuIndex !== 0 && generalSettings.menuOpen) {
        dispatch(toggleMenu());
        setTimeout(() => {
          dispatch(changeSection(pressedMenuIndex));
          setApplyAnimationReverse(false);
          setApplyAnimationVanish(false);
          setPressedMenuIndex(0);
          setApplyAnimationMenuAppear(true);
          if (menuItemPressedInContent) {
            setMenuItemPressedInContent(false);
            setTimeout(() => {
              setApplyAnimationStart(true);
            }, 800);
          }
        }, 800);
      } else if (pressedMenuIndex !== 0) {
        setTimeout(() => {
          // setImageIndex((prev) => prev - 1);
          dispatch(changeSection(pressedMenuIndex));
          setApplyAnimationReverse(false);
          setApplyAnimationVanish(false);
          setApplyAnimationMenuAppear(true);
          setPressedMenuIndex(0);
          if (menuItemPressedInContent) {
            setMenuItemPressedInContent(false);
            setTimeout(() => {
              setApplyAnimationStart(true);
            }, 800);
          }
        }, 800);
      } else if (closeContent) {
        // setApplyAnimationReverse(true);

        setTimeout(() => {
          dispatch(changeSection(0));
          setApplyAnimationVanish(false);
          setApplyAnimationMenuAppear(true);
          setApplyAnimationReverse(false);
          setCloseContent(false);
        }, 800);
      } else if (pressLogo) {
        setTimeout(() => {
          setPressLogo(false);
          setApplyAnimationMenuAppear(true);
          setApplyAnimationVanish(false);
          setApplyAnimationReverse(false);
          dispatch(changeSection(0));
        }, 800);
      }
    }
  }, [
    applyAnimationVanish,
    increaseIndex,
    decreaseIndex,
    pressedMenuIndex,
    closeContent,
    pressLogo,
    menuItemPressedInContent,
  ]);

  useEffect(() => {
    if (applyAnimationMenuAppear) {
      setTimeout(() => {
        setApplyAnimationMenuAppear(false);
      }, 1000); //this 1000 is for .animate-navbar-vanish which last 1 second (its duration is 1s)
    }
  }, [applyAnimationMenuAppear]);

  useEffect(() => {
    if (applyAnimationStart) {
      dispatch(toggleSectionContentDisplay(true));
      setApplyAnimationReverse(false);
    }
  }, [applyAnimationStart]);

  useEffect(() => {
    if (sections.displayContent) {
      setTimeout(() => {
        // window.scrollTo(0, 200);
        // const anchor = document.getElementById("scroll-anchor");
        // anchor.onClick = function (e) {
        //   e.preventDefault();
        // };
        // anchor.click();
        document.querySelector("#start-of-the-content").scrollIntoView({
          behavior: "smooth",
        });
      }, 1200);
    }
  }, [sections]);

  const handleCloseContent = () => {
    setApplyAnimationStart(false);
    setCloseContent(true);
    setApplyAnimationVanish(true);
    dispatch(toggleSectionContentDisplay(false));
  };

  const handlePressMenu = (position) => {
    // if (generalSettings.menuOpen) {
    //   dispatch(toggleMenu());
    // }
    window.scroll(0, 0);
    setApplyAnimationVanish(true);
    setPressedMenuIndex(position);
    if (sections.displayContent) {
      dispatch(toggleSectionContentDisplay(false));
      setApplyAnimationStart(false);
      setMenuItemPressedInContent(true);
    }
  };

  const handlePressLogo = () => {
    setPressLogo(true);
    setApplyAnimationVanish(true);
    if (sections.displayContent) {
      dispatch(toggleSectionContentDisplay(false));
      setApplyAnimationStart(false);
    }
  };

  const delaySectionsChange = () => {
    setCanChangeSection(false);
    setTimeout(() => {
      setCanChangeSection(true);
    }, thresholdToChangeSectionInMs);
  };

  const handleNextSection = () => {
    setApplyAnimationVanish(true);
    setIncreaseIndex(true);
    delaySectionsChange();
  };

  const handlePrevSection = () => {
    setApplyAnimationVanish(true);
    setDecreaseIndex(true);
    delaySectionsChange();
  };

  const handleMenuToggler = () => {
    dispatch(toggleMenu());
  };

  const handleCloseMenu = () => {
    setCloseMenu(true);
    setTimeout(() => {
      dispatch(toggleMenu());
      setCloseMenu(false);
    }, 450);
  };

  const handleReadMore = () => {
    setApplyAnimationStart(true);
  };

  const handleLanguageTogglerPressed = () => {
    setLanguageTogglerPressed(true);
    setTimeout(() => {
      dispatch(toggleLanguage());
      setLanguageTogglerPressed(false);
      if (!generalSettings.rtlLanguage) {
        constants.ROOT_ELEMENT.dataset.languageDirection = "right";
      } else {
        delete constants.ROOT_ELEMENT.dataset.languageDirection;
      }
    }, 800);
    handlePressLogo();
  };

  return (
    <>
      <div
        className={`main-container${setAdditionalClasses(
          ["menu-opened", "animate-menu-appear", "animate-menu-dissapear"],
          [generalSettings.menuOpen, generalSettings.menuOpen, closeMenu]
        )}`}
      >
        {!generalSettings.menuOpen && (
          <>
            <div
              className={`red-shape animate-red-shape-appear${setAdditionalClasses(
                ["animate-red-shape-appear", "animate-red-shape-vanish"],
                [applyAnimationMenuAppear, applyAnimationVanish]
              )}`}
            ></div>
            <div
              className={`yellow-shape animate-yellow-shape-appear${setAdditionalClasses(
                ["animate-yellow-shape-appear", "animate-yellow-shape-vanish"],
                [applyAnimationMenuAppear, applyAnimationVanish]
              )}`}
            ></div>
            <div className={`header-main`}>
              <div
                className="menu-icon-wide-screen"
                onClick={handleMenuToggler}
              >
                <img
                  // className="menu-icon-wide-screen"
                  src={menuIcon}
                  alt=""
                  style={{ objectFit: "contain" }}
                />
              </div>
              <div
                className="toggle-langauge-icon-wide-screen"
                // onClick={handleMenuToggler}
              >
                <LanguageToggler
                  rtl={generalSettings.rtlLanguage}
                  // onPress={handleLanguageToggler}
                  onPress={handleLanguageTogglerPressed}
                  applyClassName={sections.displayContent ? "border-white" : ""}
                />
              </div>
              <Logo
                // applyAnimationVanishClassName={applyAnimationVanish}
                applyAnimationVanishClassName={languageTogglerPressed}
                applyAnimationMenuAppearClassName={applyAnimationMenuAppear}
                onPress={handlePressLogo}
              />
              {!scrollEnableSticky && (
                <Navbar
                  onPressMenuItem={handlePressMenu}
                  onPressMenuToggler={handleMenuToggler}
                  applyAnimationVanishClassName={applyAnimationVanish}
                  applyAnimationMenuAppearClassName={applyAnimationMenuAppear}
                  onPressLanguageToggler={handleLanguageTogglerPressed}
                />
              )}
            </div>
          </>
        )}
        {sections.list.map(
          (section, index) =>
            index === sections.currentSection && (
              <div key={index}>
                <MainSectionImage
                  image={getPreloadedImage(sections.currentSection)}
                  onApplyAnimationStart={handleReadMore}
                  applyAnimationStartClassName={applyAnimationStart}
                  // onApplyAnimationReverse={() => setApplyAnimationReverse(false)}
                  applyAnimationReverseClassName={applyAnimationReverse}
                  applyAnimationVanishClassName={applyAnimationVanish}
                  displayContentEnabled={sections.displayContent}
                  homeSection={index === 0}
                  applyAnimationMenuAppearClassName={applyAnimationMenuAppear}
                />
                <MainText
                  applyAnimationVanishClassName={applyAnimationVanish}
                  applyAnimationMenuAppearClassName={applyAnimationMenuAppear}
                  title={getRightContent(
                    generalSettings.rtlLanguage,
                    section.presentation.title
                  )}
                  prefix={
                    section.presentation.prefix &&
                    getRightContent(
                      generalSettings.rtlLanguage,
                      section.presentation.prefix
                    )
                  }
                />
              </div>
            )
        )}
        {/* <div
          className={` menu-open${setAdditionalClasses(
            ["animate-menu-appear", "animate-menu-dissapear"],
            [generalSettings.menuOpen, closeMenu]
          )}`}
        > */}
        <MenuOpen
          visible={generalSettings.menuOpen}
          onPressMenuItem={handlePressMenu}
          onPressCloseMenu={handleCloseMenu}
          onPressLanguageToggler={handleLanguageTogglerPressed}
        />
        {/* </div> */}
      </div>
      {/* <div style={{ display: "flex" }}>
        <button
          onClick={() => {
            setApplyAnimationVanish(true);
            setDecreaseIndex(true);
          }}
        >
          prev
        </button>
        <button
          onClick={() => {
            setApplyAnimationVanish(true);
            setIncreaseIndex(true);
          }}
        >
          next
        </button>
      </div> */}
      {sections.displayContent && !generalSettings.menuOpen && (
        <>
          {scrollEnableSticky && (
            <Navbar
              onPressMenuItem={handlePressMenu}
              onPressMenuToggler={handleMenuToggler}
              applyAnimationVanishClassName={applyAnimationVanish}
              applyAnimationMenuAppearClassName={applyAnimationMenuAppear}
              applyStickyNavbarClassName={"navbar-sticky"}
              onPressLanguageToggler={handleLanguageTogglerPressed}
            />
          )}
          <div className="display-content">
            <img
              src={closeIcon}
              alt=""
              className="close-icon"
              onClick={handleCloseContent}
            />
            <a href="#start-of-the-content" id="scroll-anchor"></a>
            <div id="start-of-the-content">
              {getSectionContent(sections.currentSection, [
                null,
                <Section1 />,
                <Section2 />,
                <Section3 />,
                <Section4 />,
                <Section5 />,
                <Section6 />,
              ])}
            </div>
            <Footer
              onPressNextSection={() =>
                handlePressMenu(
                  getNextSectionContentIndex(
                    sections.currentSection,
                    sections.list.length
                  )
                )
              }
              onPressPrevSection={() =>
                handlePressMenu(
                  getPrevSectionContentIndex(
                    sections.currentSection,
                    sections.list.length
                  )
                )
              }
              prevContentTitle={getRightContent(
                generalSettings.rtlLanguage,
                getMenuItems()[
                  getPrevSectionContentIndex(
                    sections.currentSection,
                    sections.list.length
                  )
                ].label
              )}
              nextContentTitle={getRightContent(
                generalSettings.rtlLanguage,
                getMenuItems()[
                  getNextSectionContentIndex(
                    sections.currentSection,
                    sections.list.length
                  )
                ].label
              )}
            />
          </div>
        </>
      )}
    </>
  );
}

export default MainContainer;
